import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { JobApplicationService } from './job-application.service';
import { AuthenticationService, UserService } from '../_services';
import { state } from '@angular/animations';
import { AuthGuard } from '../_helpers';
import Swal from 'sweetalert2';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-job-application',
  templateUrl: './job-application.component.html',
  styleUrls: ['./job-application.component.css']
})
export class JobApplicationComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private jobApplicationService: JobApplicationService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private userAccountService: UserService
  ) {
  }

  public vacancy: any;
  private currentUser: any;
  private loggedInUser: any;
  public applying: boolean;
  public applied: boolean;
  public showDetails: boolean;


  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getVacancyById(this.route.snapshot.params.vacantId);
  }

  getVacancyById(vacantId: bigint) {
    return this.jobApplicationService.getVacancyById(vacantId)
      .subscribe(response => {
        this.vacancy = response;
        if (this.vacancy == null) {
          this.showDetails = false;
        } else {
          this.showDetails = true;
        }
      });
  }

  /*async c(id: any) {

    await this.getCurrentUser();
    console.log(this.loggedInUser);
    if (this.authenticationService.currentUserValue) {
      console.log('The user is logged in....', this.loggedInUser.id, this.authenticationService.currentUserValue);

    } else {
      console.log('Failed because the user is not logged in....');
      this.router.navigate(['/login']);

    }
  }*/

  applyVacancy(id: any) {
    this.applying = true;
    if (this.authenticationService.currentUserValue) {
      return this.userAccountService.getCurrentUser()
        .subscribe(user => {
          this.loggedInUser = user;
          this.jobApplicationService.applyVacancy(id)
            .subscribe(resp => {
              console.log("=============>> response : " + resp.reply + "  response : " + resp)
              let respo = "" + resp.reply;
              if (respo.match("successfully applied")) {
                Swal.fire(
                  'Done!',
                  resp.message,
                  'success'
                );
                this.router.navigate(['/dashboard/manage-applications']);
              } else if (resp.reply == "vacancy present") {
                Swal.fire(
                  'Exists!',
                  resp.message,
                  'warning'
                );
                this.router.navigate(['/dashboard/manage-applications']);
              } else if (resp.reply === "vacancy closed") {
                Swal.fire(
                  'Vacancy closed!',
                  resp.message,
                  'warning'
                );
              } else if (resp.reply === "no work experience") {
                Swal.fire(
                  'You profile is incomplete!',
                  resp.message,
                  'warning'
                );
                this.router.navigate(['/dashboard/work-experience']);
              } else if (resp.reply === "no profile") {
                Swal.fire(
                  'You profile is incomplete!',
                  resp.message,
                  'warning'
                );
                this.router.navigate(['/dashboard/personal-info']);
              } else if (resp.reply === "no profile") {
                Swal.fire(
                  'You profile is incomplete!',
                  resp.message,
                  'warning'
                );
                this.router.navigate(['/dashboard/personal-info']);
              } else if (resp.reply === "no cv") {
                Swal.fire(
                  'You profile is incomplete!',
                  resp.message,
                  'warning'
                );
                this.router.navigate(['/dashboard/cv']);
              } else if (resp.reply === "no education") {
                Swal.fire(
                  'You profile is incomplete!',
                  resp.message,
                  'warning'
                );
                this.router.navigate(['/dashboard/educational-info']);
              } else if (resp.reply == "error") {
                Swal.fire(
                  'Error!',
                  'Ask system admin for assistance!',
                  'warning'
                );
              }

            },
              error => {
                this.applying = false;
                Swal.fire(
                  'Error!',
                  'Something went wrong.',
                  'error'
                );
              },
              // () => {
              //   this.router.navigate(['/dashboard/manage-applications']);
              // }
            );
        });
    } else {
      // console.log('Failed because the user is not logged in....');
      this.router.navigate(['/login']);
    }
  }
}
